import { useEffect, useState } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import type { CampaignDraft } from "src/services/CampaignDraftTypes";
import { getDraftWarningOutcome } from "./CampaignDraftUtils";

/** What changed since a draft was saved, and the one-time notice telling the user about it. */
export const useDraftWarnings = (draft: CampaignDraft | null) => {
  const { t } = useTranslation();
  const [outcome] = useState(() => getDraftWarningOutcome(draft?.warnings));
  const { missingLists, isNameTaken } = outcome;

  useEffect(() => {
    if (missingLists.length > 0) {
      message.warning(t("campaignFlow.draft.missingLists", { lists: missingLists.join(", ") }));
    }
    if (isNameTaken) {
      message.warning(t("campaignFlow.draft.nameTaken"));
    }
  }, [isNameTaken, missingLists, t]);

  return outcome;
};
